export const WINE_SOURCES = ['manual', 'website_jsonld', 'website_scrape', 'ai_web_search'];
export var WineType;
(function (WineType) {
    WineType["RED"] = "RED";
    WineType["WHITE"] = "WHITE";
    WineType["ROSE"] = "ROSE";
    WineType["SPARKLING"] = "SPARKLING";
    WineType["DESSERT"] = "DESSERT";
    WineType["FORTIFIED"] = "FORTIFIED";
    WineType["OTHER"] = "OTHER";
})(WineType || (WineType = {}));
// Wine availability enumeration constants
export const WINE_AVAILABILITY = [
    'widely distributed',
    'limited distribution',
    'winery only',
    'wine club only',
    'allocation list only',
    'not available',
    'unknown'
];
// Wine status enumeration constants
export const WINE_STATUS = ['draft', 'published', 'archived'];
